var map = {
	"./audiology_parameters.svg": "5ef3",
	"./bio_param.svg": "f822",
	"./biometric_parameters.svg": "e8e0",
	"./blood_drop.svg": "d1cd",
	"./body_composition.svg": "32e4",
	"./evollu-logo.svg": "d49f",
	"./eye.svg": "d950",
	"./footer.svg": "3eed",
	"./frailty.svg": "6a70",
	"./geriatric_parameters.svg": "8da0",
	"./geriatrics.svg": "ee84",
	"./heart.svg": "0d7a",
	"./info_circle.svg": "a060",
	"./left_ear.svg": "2c3f",
	"./optometry.svg": "7e6d",
	"./optometry_parameters.svg": "ddac",
	"./oximetry.svg": "532d",
	"./recommendation_checkmark.svg": "9e4a",
	"./reference_values.svg": "d0ee",
	"./right_ear.svg": "dc90",
	"./sarcopenia.svg": "9334",
	"./spirometry.svg": "818f",
	"./temperature.svg": "e2f0",
	"./user.svg": "aa0a",
	"./warning_yellow.svg": "7e2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a820";